import { useRef, useCallback } from 'react';
import {
  useMeetingSelector,
  useStableEvent
} from '../meeting/meetingProviderContextDef';
import { events } from '../utils';

const NOOP = () => {};

const selectMeeting = s => s.meeting;

/**
 *
 * @param {{
 *  onTranscriptionStateChanged?: Function,
 *  onTranscriptionText?: Function,
 * }} options
 * @returns {{
 *  startTranscription: ( data: Object ) => void
 *  stopTranscription: () => void
 * }}
 */
const useTranscription = ({
  onTranscriptionStateChanged = NOOP,
  onTranscriptionText = NOOP
} = {}) => {
  const meeting = useMeetingSelector(selectMeeting);

  const meetingRef = useRef(meeting);
  meetingRef.current = meeting;

  useStableEvent(
    events['transcription-state-changed'],
    onTranscriptionStateChanged
  );
  useStableEvent(events['transcription-text'], onTranscriptionText);

  /**
   * @param {{webhookUrl?:string, modelConfig?:any}} config?
   */
  const startTranscription = useCallback(async config => {
    if (!meetingRef.current) return;
    return await meetingRef.current.startTranscription(config);
  }, []);

  const stopTranscription = useCallback(async () => {
    if (!meetingRef.current) return;
    return await meetingRef.current.stopTranscription();
  }, []);

  return { startTranscription, stopTranscription };
};

export default useTranscription;
